var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import CalendarEvents from "./aiActions/CalendarEvents";
import SlotSelection from "./aiActions/SlotSelection";
import DateSelection from "./aiActions/DateSelection";
var AIActionComponent = function (props) {
    var action = props.action, executeAiAction = props.executeAiAction, data = props.data;
    useEffect(function () {
        if (action == "collect_email" && props.executeAiAction)
            props.executeAiAction(action);
    }, [action]);
    var actiontriggeredAsMessage = function (message, internalMessageToAI) {
        props.executeAiAction &&
            props.executeAiAction(action, message, internalMessageToAI);
    };
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "".concat(executeAiAction ? "select-order" : "") }, { children: (function () {
                var _a, _b, _c;
                switch (action) {
                    case "delete":
                        return (_jsx(CalendarEvents, { events: data.appointments, executeAction: executeAiAction
                                ? function (eventId, name) {
                                    actiontriggeredAsMessage("Delete event:" + name, "My appointment id is " + eventId);
                                }
                                : null, action: action }));
                    case "fetch_list":
                        return (_jsx(CalendarEvents, { events: (_a = data.appointments) === null || _a === void 0 ? void 0 : _a.events, executeAction: executeAiAction
                                ? function (eventId, name) {
                                    actiontriggeredAsMessage("Delete event: " + name, "My appointment id is " + eventId);
                                }
                                : null, action: action }));
                    case "requires_slot_duration":
                        return (_jsx(DateSelection, { slots: (_b = data.slot_durations) === null || _b === void 0 ? void 0 : _b.slots, executeAction: executeAiAction
                                ? function (message, internalMessageToAI) {
                                    actiontriggeredAsMessage(message, internalMessageToAI);
                                }
                                : null }));
                    case "requires_slot_selection":
                        return data.available_slots &&
                            ((_c = data.available_slots.slots) === null || _c === void 0 ? void 0 : _c.length) > 0 ? (_jsx(SlotSelection, { slots: data.available_slots.slots, executeAction: executeAiAction
                                ? function (message, internalMessageToAI) {
                                    actiontriggeredAsMessage(message, internalMessageToAI);
                                }
                                : null })) : ("");
                }
            })() })) }));
};
export default AIActionComponent;
